import React, { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '../Icon';
import isUnstable from '../utils/isUnstable';

var MenuItem = function MenuItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      iconName = _ref.iconName,
      iconType = _ref.iconType,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? ' ' : _ref$name,
      onClick = _ref.onClick,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value;
  isUnstable('MenuItem');
  var ntClass = cx({
    dropdown__link: true,
    dropdown__item: true,
    'hover-highlight--primary': !disabled,
    'dropdown__item--disabled': disabled
  }, className);
  return /*#__PURE__*/React.createElement("div", {
    "aria-disabled": disabled,
    "aria-label": name,
    className: ntClass,
    role: "menuitem",
    tabIndex: -1,
    onClick: disabled ? null : function (e) {
      return onClick(e, value);
    },
    onKeyPress: disabled ? null : function (e) {
      return onClick(e, value);
    }
  }, iconName ? /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    type: iconType,
    className: "marginright-sm"
  }) : null, name, Children.map(children, function (child) {
    return cloneElement(child, {
      disabled: disabled
    });
  }));
};

MenuItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  iconName: PropTypes.string,
  iconType: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
MenuItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MenuItem",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "defaultValue": {
        "value": "' '",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "iconName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "iconType": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
export default MenuItem;